import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 'auto !important',
    maxWidth: contentMaxWidth,
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: 0,
    position: 'relative',
  },

  headerContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 1rem',
    marginBottom: '1.75rem',

    '& span': {
      padding: '0.3rem 0.4rem',
      borderRadius: '2rem',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
      color: '#fff',
    },
  },

  headerText: {
    '& h1': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '1rem',
      padding: 0,

      '& span': {
        fontFamily: 'Sora',
        fontWeight: '400',
        fontSize: '34px',
        lineHeight: '42px',
        padding: '1rem 0',
        color: '#000000',
      },
    },

    '& div': {
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      marginTop: '-8px',

      '& h4': {
        padding: '0',
        margin: '0',
        fontWeigth: '700',
      },

      '& h5': {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '0',
        padding: '0',
        margin: '0',
        fontFamily: 'Nunito',
        fontWeight: '600',
        fontSize: '16px',
        lineHeight: '22px',
      },
    },
  },

  title: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1rem',
    padding: '1rem',
    paddingTop: 0,

    '& h2': {
      fontFamily: 'Sora',
      fontWeight: '600',
      fontSize: '20px',
      lineHeight: '32px',
    },
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: '1.75rem',
    padding: '1rem',

    '& p': {
      fontFamily: 'Sora',
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '24px',
      margin: 0,
      padding: 0,
    },

    '& span': {
      maxWidth: '600px !important',
      width: '100% !important',
      font: 'Nunito',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '24px',
    },
  },

  contentConnect: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100%',
    gap: '0.25rem',
    padding: '1rem',
  },

  alert: {
    width: '100%',
    backgroundColor: getRGBA('#2E7D32', 0.08),
    color: '#2E7D32 !important',
    padding: '0 1rem',

    '& .MuiSvgIcon-root': {
      color: '#2E7D32 !important',
    },

    '& h6': {
      font: 'Sora',
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '24px',
      padding: 0,
      margin: 0,
    },

    '& span': {
      font: 'Nunito',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
    },
  },

  info: {
    maxWidth: '648px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    padding: '1.75rem 0',

    '& h6': {
      font: 'Nunito',
      fontWeight: 700,
      fontSize: '14px',
      lineHeight: '24px',
      padding: '0 !important',
      margin: '0 !important',
    },

    '& span': {
      font: 'Nunito',
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '20px',
      padding: 0,
      margin: 0,
    },
  },

  btn: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.35rem',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '1rem 0',
    height: '36px',

    '&:disabled': {
      cursor: 'not-allowed',
      height: '36px',
    },
  },

  btns: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.35rem',
    width: '100%',
    alignItems: 'center',
  },
}))

export { useStyles }
